import { QuoteToolPreselectedModes } from '@lx/shared/utils';

export type AcademicYearAbroadDeepLinkParameters = {
  preselectedMode?: QuoteToolPreselectedModes;
  languageCode?: string;
  courseCode?: string;
  schoolCode?: string;
  duration?: number;
  startDate?: string;
  deeplinkType?: string;
};
